"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_ADMIN_COMPANY_STORES = void 0;
var client_1 = require("@apollo/client");
var fragments_1 = require("../fragments");
exports.GET_ADMIN_COMPANY_STORES = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query AdminCompanyStores($input: AdminCompanyStoresInput!) {\n    adminCompanyStores(input: $input) {\n      hasMore\n      count\n      results {\n        ...AdminStore\n      }\n    }\n  }\n  ", "\n"], ["\n  query AdminCompanyStores($input: AdminCompanyStoresInput!) {\n    adminCompanyStores(input: $input) {\n      hasMore\n      count\n      results {\n        ...AdminStore\n      }\n    }\n  }\n  ", "\n"])), fragments_1.ADMIN_STORE_FRAGMENT);
var templateObject_1;
